.c-accordion {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  ::slotted(*) {
    flex-basis: 100%;
  }
}
